import {Component, input, output} from '@angular/core';

import {SharedModule} from '../../../../../shared/shared.module';
import {DeclinaisonDenreeData} from './declinaison-denree-data';

@Component({
  selector: 'yo-declinaison-denree',
  templateUrl: './declinaison-denree.component.html',
  styleUrls: ['../declinaison-produit-dialog-edit.component.scss'],
  standalone: true,
  imports: [
    SharedModule
  ]
})
export class DeclinaisonDenreeComponent {

  data = input.required<DeclinaisonDenreeData>();

  changeCompteComptable = output<number>();
  changeTaxe = output<number>();
  changeUniteDeMesure = output<number>();
  changeRatioUniteTechnique = output<string>();
  changeInverseRatioUniteTechnique = output<string>();
  changeZoneDeStockage = output<number>();
  changeTacheApprovisionnement = output<number>();
  changeTacheSortie = output<number>();
  changeFamilleEgalim = output<number>();
  changeDlc = output<number>();
  changeStockMinimum = output<number>();
  changeRatioVolume = output<number>();
  changePrixDeVente = output<number>();
}
